export default {"src":"/static/spa/fresh-spa/_next/static/media/icon-frozen.2ca4a0ab.svg","height":135,"width":140,"blurWidth":0,"blurHeight":0};